import { Controller } from "@hotwired/stimulus"
import Plyr from 'plyr'
import '../../src/css/modules/plyr.scss'
import Hls from 'hls.js'

export default class extends Controller {

  initialize() {
    const controls = ["play", "progress", "volume", "settings", "fullscreen"]
    window.player = new Plyr(this.element, {
      controls: controls
    })
    const source = this.element.dataset.source
    if (!source) return

    if (source.includes('.m3u8') && Hls.isSupported()) {
      const hls = new Hls()
      hls.loadSource(source)
      hls.attachMedia(this.element)
    } else {
      this.element.src = source
    }
  }

  // action
  destroy() {
    if (window.player) {
      window.player.destroy()
    }
  }

}
